import React, { useMemo } from 'react'
import { StatsConf, StatsConfKeys } from '../statsConf'
import { ChartOptionsType, TimeseriesType } from '../../../utils/hooks/performanceStats/useTimeseries'
import Timeseries from './Timeseries'

type TimeseriesProps = {
  timeseriesData?: TimeseriesType
  chartItems: StatsConfKeys[]
  chartItemsVisibility: Record<StatsConfKeys, boolean>
  toggleVisibility: (name: StatsConfKeys) => void
  dateFormat: string
  timezone: string
  chartOptions: ChartOptionsType
  isPublisherStats: boolean
  loading: boolean
  error?: Error
}

const PerformanceStatsGraph: React.FC<TimeseriesProps> = ({
  timeseriesData,
  chartItems,
  chartItemsVisibility,
  toggleVisibility,
  dateFormat,
  timezone,
  chartOptions,
  isPublisherStats,
  error,
  loading,
}) => {
  const data = useMemo(
    () => timeseriesData?.timeseries.map((item) => Object.assign({}, item.stats, { date: item.date })) ?? [],
    [timeseriesData]
  )

  const updatedChartItemsVisibility = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(chartItemsVisibility).filter(([key]) => chartItems.includes(key as StatsConfKeys))
      ) as Record<StatsConfKeys, boolean>,
    [chartItemsVisibility, chartItems]
  )

  return (
    <Timeseries
      total={timeseriesData?.stats ?? {}}
      data={data}
      timezone={timezone}
      statStyles={StatsConf}
      chartItemsVisibility={updatedChartItemsVisibility}
      toggleVisibility={toggleVisibility}
      translationPrefix={`stats.customDisplay.${isPublisherStats ? 'publisher' : 'advertiser'}`}
      dateFormat={dateFormat}
      chartOptions={chartOptions}
      error={error}
      loading={loading}
    />
  )
}

export default PerformanceStatsGraph
